import { groupLabel } from 'owa-locstrings/lib/strings/grouplabel.locstring.json';
import { publicDistributionListLabel } from 'owa-locstrings/lib/strings/publicdistributionlistlabel.locstring.json';
import {
    contactListsLabel,
    yourContactListsLabel,
} from 'owa-locstrings/lib/strings/contactlistslabel.locstring.json';
import { directoryLabel } from 'owa-locstrings/lib/strings/directorylabel.locstring.json';
import { showPeopleLabel } from '../../strings.locstring.json';
import loc from 'owa-localize';
import {
    HubPersona,
    PersonType,
    createActionFactory,
    Feature,
    contactListsLeftNavItemId,
    contactsLeftNavItemId,
    ThunkDispatch,
    favoritesLeftNavItemId,
    isConsumer,
} from '../../../shared';

import { searchRefresh } from '../../../searchbox';

export const enum SearchResultType {
    None,
    Contact,
    PrivateDistributionList,
    PublicDistributionList,
    Group,
    Directory,
}

export const searchResultTypeLabelClickedAction = createActionFactory<{
    resultType: SearchResultType;
    folderId: string;
}>('SearchResultTypeLabelClickedAction', Feature.Search);

export const getSearchResultTypeFromHubPersonaAndQueryData = (
    element: HubPersona,
    folderId?: string
): SearchResultType => {
    // If we are searching within a folder, the result type labels should match the folder to be consistent
    // i.e. don't mention that we happen to be a contact when we are searching within the directory as this is confusing.
    if (folderId) {
        switch (folderId) {
            case contactsLeftNavItemId:
                return SearchResultType.Contact;
            case contactListsLeftNavItemId:
                return SearchResultType.PrivateDistributionList;
            case favoritesLeftNavItemId:
            default:
            // Don't override, continue to the element matching logic below
        }
    }

    switch (element.type) {
        case PersonType.FavoritePerson:
        case PersonType.Person:
            if (element.type === PersonType.FavoritePerson) {
                return SearchResultType.None;
            }
            if (
                element.type === PersonType.Person &&
                element.linkedContacts &&
                element.linkedContacts.some(link => link.isWritable)
            ) {
                return SearchResultType.Contact;
            }
            return element.type === PersonType.Person && element.info.GALContactGuid
                ? SearchResultType.Directory
                : SearchResultType.None;
        case PersonType.PublicDistributionList:
            return SearchResultType.PublicDistributionList;
        case PersonType.PrivateDistributionList:
            return SearchResultType.PrivateDistributionList;
        case PersonType.GroupBasicData:
        case PersonType.Group:
            return SearchResultType.Group;
        default:
            return SearchResultType.None;
    }
};

export const getTypeLabelFromSearchResultType = (resultType: SearchResultType): string => {
    switch (resultType) {
        case SearchResultType.Contact:
            return loc(showPeopleLabel);
        case SearchResultType.Directory:
            return loc(directoryLabel);
        case SearchResultType.PrivateDistributionList:
            return isConsumer() ? loc(contactListsLabel) : loc(yourContactListsLabel);
        case SearchResultType.PublicDistributionList:
            // TODO: This is currently singular, adding the plural string and will bump/consume new plural string.
            return loc(publicDistributionListLabel);
        case SearchResultType.Group:
            return loc(groupLabel);
        case SearchResultType.None:
        default:
            return undefined;
    }
};

const getFolderIdFromSearchResultType = (resultType: SearchResultType): string => {
    switch (resultType) {
        case SearchResultType.Contact:
            return contactsLeftNavItemId;
        case SearchResultType.PrivateDistributionList:
            return contactListsLeftNavItemId;
        default:
            return undefined;
    }
};

export const searchResultTypeLabelClicked = (dispatch: ThunkDispatch) => (
    resultType: SearchResultType
) => {
    const folderId = getFolderIdFromSearchResultType(resultType);
    dispatch(searchResultTypeLabelClickedAction({ resultType, folderId }));
    dispatch(searchRefresh);
};
